import { render, staticRenderFns } from "./OneTimePayment.vue?vue&type=template&id=501c5208&scoped=true&"
import script from "./OneTimePayment.vue?vue&type=script&lang=js&"
export * from "./OneTimePayment.vue?vue&type=script&lang=js&"
import style0 from "./OneTimePayment.vue?vue&type=style&index=0&id=501c5208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501c5208",
  null
  
)

export default component.exports